import {
  FilterDocumentDateFilter,
  FilterDocumentDurationFilter,
} from '@griply/types';
import React from 'react';
import { PopupMenu, PopupMenuTitle } from 'shared/components/ui/popup-menu';
import { FilterDocuments } from 'shared/constants';
import {
  ActiveFilter,
  FilterGroup as FilterGroupType,
} from 'shared/types/filter';
import { ID } from 'shared/types/id';

import * as Styled from './filter-context-menu.style';
import { FilterGroup } from './filter-group';

export type FilterContextMenuProps = Omit<
  React.ComponentProps<typeof PopupMenu>,
  'children'
> & {
  title: string;
  options: FilterGroupType[];
  activeOptions: ActiveFilter[];
  onOption: (options: {
    id: ID;
    value?: string | string[];
    durationFilter?: FilterDocumentDurationFilter | null;
    dateFilter?: FilterDocumentDateFilter | null;
  }) => void;
  onReset: () => void;
};

export const FilterContextMenu: React.FC<FilterContextMenuProps> = ({
  title,
  options,
  onOption,
  activeOptions,
  onReset: _onReset,
  ...rest
}) => {
  const footerOptions = options.filter(
    (option) =>
      option.id === FilterDocuments.ResetFilterDocumentID ||
      option.id === 'saveAsSmartList', // potential future id
  );

  const bodyOptions = options.filter(
    (option) => !footerOptions.find((footer) => footer.id === option.id),
  );

  return (
    <PopupMenu {...rest} width={328} focusOnOpen>
      <PopupMenuTitle title={title} hasBottomBorder={!!options.length} />
      <Styled.GroupsContainer>
        {bodyOptions.map((group, index) => (
          <FilterGroup
            key={group.id}
            group={group}
            onOption={onOption}
            activeOptions={activeOptions}
            hasBottomBorder={index < bodyOptions.length - 1}
          />
        ))}
      </Styled.GroupsContainer>
      {!!footerOptions.length && (
        <Styled.FooterContainer>
          {footerOptions.map((group) => (
            <FilterGroup
              key={group.id}
              group={group}
              onOption={onOption}
              activeOptions={activeOptions}
            />
          ))}
        </Styled.FooterContainer>
      )}
    </PopupMenu>
  );
};
